<template>
    <div class="container">

        <div class="container">
            <div class="h-100 d-flex justify-content-center align-items-center">


                <div class="mt-5 py-4" style="min-width:400px !important;background: #f2f2f2 !important;">
                    <div class="text-center">
                        <i class="bi bi-check-circle-fill text-primary" style="font-size: 6rem; color: cornflowerblue;"></i>
                        <h6 class="font-weight-bold">Order Completed</h6>



                        <h1 v-if="order_id.partial" class="py-2">Paid {{convertCurrencyToLocal(order_id.total_amount - order_id.balance)}}</h1>
                        <h1 v-else class="py-2">Paid {{convertCurrencyToLocal(order_id.total_amount)}}</h1>
                        <div v-if="order_id.partial && order_id.balance > 0" >
                        <hr />
                        <h2 class="py-2">Balance {{convertCurrencyToLocal(order_id.balance)}}</h2>
                        </div>

                        <small class="text-gray font-weight-bold">{{order_id.qty}} items</small>
                        <p class="text-primary font-weight-bold py-4">Order Id:{{order_id.order}}</p>
                        <p v-if="userDetails.company && userDetails.company.companysettings && userDetails.company.companysettings.enable_tims && !order_id.customer" class="text-dark py-2 px-1">Ask customer if they need an Etims compliant receipt | <a href="#" v-b-modal="'customer-search-modal'">Register Customer</a></p>
                        <div class="btn-group w-100 px-2">
                            <a  href="/makesale" class="btn btn-secondary btn-sm"><i class="bi bi-cart"></i> Make a sale</a>


                            <a :href="printUrl" v-if="!loading" target="_blank" class="btn btn-primary btn-sm  mx-1"><i class="bi bi-printer"></i> Print Receipt</a>

                                <a   target="_blank" v-on:click="sendReceiptToCustomer(order_id.id)" class="btn btn-secondary btn-sm"><i class="bi bi-telegram"></i> Send Receipt</a>

                            <a class="btn btn-outline-secondary btn-sm px-2" style="color: #28D146;" target="_blank"  v-if="order_id.customer &&order_id.customer.phone" :href='"https://wa.me/" + convertToInternational(order_id.customer.phone) + "?text=Hello,%20Please%20see%20order%20from%20"+ encodeURIComponent(userDetails.company?.name || "") +"%20" + $platformBrand.appUrl + "/customer-order-view/" + order_id.id + "?from=whatsapp&utm=whatsapp"'  ><i class="bi bi-whatsapp"></i> </a>

                        </div>
                        <!--<div class="mt-lg-5">-->
                            <!--<a href="/makesale" class="btn btn-outline-primary">New Order </a>-->
                        <!--</div>-->

                    </div>





                </div>
            </div>
        </div>
  <b-modal ref="customerSearch" id="customer-search-modal" hide-footer>
    <div class="text-center"><h5>Add Customer</h5></div>
    <div class="py-3">
                <input v-model="customerData.searchTerm" type="text" class="form-control"
                    placeholder="Search by name, email, or phone number">
                <table class="table table-striped table-sm"
                    v-if="customerData.customer.length > 0 && customerData.searchTable===true">
                    <thead>
                        <th>Name</th>
                        <th>Phone</th>
                        <th>Email</th>

                    </thead>
                    <tbody>
                        <tr v-for="customer in customerData.customer" :key="customer.id"
                            @click="rowSelected(customer)">
                            <td>{{ customer.full_name }}</td>
                            <td>{{ customer.phone }}</td>
                            <td>{{ customer.email }}</td>



                        </tr>
                    </tbody>

                </table>

            </div>
            <p>Can't find Customer? &nbsp;<a href="#" v-b-modal="'new_customer_form'" >Add New Customer</a></p>

  </b-modal>
<b-modal ref="customerdetails" id="new_customer_form" hide-footer >

    <form v-on:submit="newCustomer">
        <div class="form-row py-1">
            <div class="col-12">

                <input class="form-control border-bottom"  v-model="customerform.name"  type="text" placeholder="Full Name"/>
                <!--<small class="text-danger">{{ errors.first('l_name') }}</small>-->
            </div>
        </div>
        <div class="form-group py-1">

            <input class="form-control border-bottom" name="c_email" v-model="customerform.email" type="email" placeholder="Email"/>


        </div>
        <div class="form-group py-1">

            <input class="form-control border-bottom" name="krapin" v-model="customerform.krapin" type="text" placeholder="KRA PIN"/>


        </div>
        <div class="form-group">
            <vue-tel-input :placeholder="712345678" v-model="customerform.phone"></vue-tel-input>
            <!--<input class="form-control border-bottom"   v-model="customerform.phone" type="text" placeholder="Phone Number"/>-->


        </div>

        <div class="form-group pt-3">
            <button class="btn btn-primary btn-block">Add Customer</button>
        </div>
    </form>
</b-modal>
    </div>

</template>

<script>
import {mapGetters} from 'vuex'
    export default {
        name: "checkoutdone",
        props: [
            'order_id',
        ],

        data() {

            return {
                orderId: '',
                customerform:{
                  name:'',
                  phone:'',
                  email:'',
                  krapin:'',
                },
                customerData:{
                    searchTerm:'',
                    filteredCustomers:'',
                    searchTable:false,
                    customer:{}
                },
                customer_id:'',
                searchTimeout:'',
                printUrl:'',
                loading:false
            }
        },
        computed: {

         ...mapGetters(['userDetails'])
     },
     mounted(){
        this.sendTimsData()
     },
        methods: {

            printInvoice(){
                window.location.href = '/print_invoice/' + this.order_id.id;

            },
            async sendTimsData(){
                this.loading = true

                if(this.userDetails.company && this.userDetails.company.companysettings && this.userDetails.company.companysettings.enable_tims){
                    const payload = {
                        'transaction_type': (this.order_id.customer ) ? 'invoice': 'sale'
                    }
                    await axios.get(`/api/fiscal/receipts-new/${this.order_id.id}`,{params:payload}).then(results=>{
                    if(results.data.success)
                    {
                        this.printUrl = `/print_invoice/${this.order_id.id}?tims=1`;
                        // window.location.href = this.printUrl
                         this.loading = false
                    }

                }).catch(error=>{

                      this.printUrl = `/print_invoice/${this.order_id.id}`;
                       this.loading = false
                    console.log(error)
                })
                }else{
                 this.printUrl = `/print_invoice/${this.order_id.id}`;
                  this.loading = false
                }






            },
            rowSelected(customer)
            {
                this.customer_id = customer.id;
                this.sendReceiptToCustomer();

            },
            newCustomer(e)
            {
                e.preventDefault();
                axios.post('/api/newcustomer',{
                    phone_no:this.customerform.phone,
                    email:this.customerform.email,
                    f_name:this.customerform.name,
                    krapin:this.customerform.krapin,
                    order_id:this.order_id.id
                }).
                then(result=>{
                    // now send message to customer
                    if(result.data.type == "success"){

                    this.$bvModal.hide('customer-search-modal');
                        this.$toasts.push({
                            "type":"success",
                            "message":"Customer been created successfully"
                        })

                         window.location.reload()

                    }


                }).catch(e=>{
                    console.log(e.response.data)
                });
            },
            sendReceiptToCustomer(){

                if(this.order_id.customer !== null || this.customer_id !=='')
                {
                    let customerid = (this.order_id.customer === null) ? this.customer_id : this.order_id.customer.id;




                    axios.post('/api/customer/sendreceipt',{customer_id:customerid,order_id:this.order_id.id}).then(results=>{

                      if(results.data.message === 'failed')
                      {
                        this.$toasts.push({
                            "type":"error",
                            "message":"Customer has no phone number"
                        })

                      }
                      else{
                        window.location.href='/';
                      }
                    }).catch(error=>{
                        console.log(error.response.data)
                    })
                }
                else {
                    this.getCustomers();
                    this.$refs['customerSearch'].show();

                }

            },
            convertToInternational(number) {
                    // Assuming the local number starts with '0' and has 10 digits
                    if (number.startsWith('0') && number.length === 10) {
                        return '254' + number.substring(1);
                    }
                    },
            getCustomers()
            {

                axios.get(`/api/allcustomers?search=${this.customerData.searchTerm}`)
                    .then(result => {

                        this.customerData.customer = result.data.data;


                    });
            },
            // searchCustomers() {
            //     const searchTerm = this.customerData.searchTerm.toLowerCase();

            //     this.customerData.filteredCustomers = this.customerData.customer.filter(customer =>
            //         (customer.name && customer.name.toLowerCase().includes(searchTerm)) ||
            //         (customer.full_name && customer.full_name.toLowerCase().includes(searchTerm)) ||
            //         (customer.email && customer.email.toLowerCase().includes(searchTerm)) ||
            //         (customer.phone && customer.phone.includes(searchTerm))
            //     );
            // },
    },
    watch:{
            'customerData.searchTerm': function() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => {
                     // Reset to first page on search

                    this.getCustomers();
                }, 500); // Debounce delay (500ms)
    },

        // userDetails: {
        //     immediate: true,
        //     handler(val) {
        //         if (val.company) {
        //             this.companyInfo = val.company;
        //         }
        //     }

        // },
        }
    }
</script>

<style scoped>

</style>
